import React from 'react';
import { AssumedDefaults, summariseAssumed } from '../utils/assumedDefaults';

// F30: shown whenever the engine filled in a missing input with a default, so a
// figure is never quietly built on a value nobody chose. Edit the property to
// set the real value.
const AssumedDefaultsNotice: React.FC<{ assumed?: AssumedDefaults | null; className?: string }> = ({ assumed, className }) => {
  const rows = summariseAssumed(assumed);
  if (rows.length === 0) return null;
  return (
    <div className={`bg-amber-50 border border-amber-300 text-amber-900 rounded-lg p-4 text-sm ${className || ''}`}>
      <div className="font-semibold mb-1">⚠️ Defaults were used for missing inputs</div>
      <p className="mb-2">These figures were not set on the property, so the engine assumed the values below. Edit the property to use real values.</p>
      {rows.map(({ property, items }) => (
        <div key={property} className="mb-1">
          <span className="font-medium">{property}:</span> {items.join('; ')}
        </div>
      ))}
    </div>
  );
};

export default AssumedDefaultsNotice;
